import {
  Customer,
  CustomFormReport,
  CustomFormReportFormData,
  CustomFormReportType,
  FpCompany,
  User
} from '@flicent/fieldpulse-react-component-library-frontend';

import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  publicLinkId: string;
}

interface ResponseDataType {
  report_type: CustomFormReportType;
  public_link_author: User | null;
  company: FpCompany | null;
  customer: Customer | null;
  custom_form_report: CustomFormReport;
  forms_data: CustomFormReportFormData[];
  is_public_link_filled_status: boolean;
  filled_pdf_generation_progress: {
    progress: number;
    current_step: string;
  } | null;
  filled_pdf_generation_error_detail: string | null;
  filled_pdf_file_url: string | null;
}

export const getCustomFormReportPublicLinkRequest = ({ publicLinkId }: RequestParams): Promise<ResponseDataType> => {
  return ApiServiceInstance.makeRequest(`/public/${ publicLinkId }`);
};